// extracted by mini-css-extract-plugin
module.exports = {"title":"_3e6Nir","active":"_3C8X1O"};